import { IRatePlan } from 'modules/settings/models';
import API from 'services/api';

export const getRatePlans = (excludeUnits: boolean): Promise<IRatePlan[]> => {
  return API.get('/api/accommodation/rate-plan', { params: { excludeUnits } }).then(
    res => res?.data,
  );
};
